import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Item } from "../../components/Menu";
import { MenuItem } from "../../components/Menu";
import { useCommunicationHandlers } from "../UsefulLinks";
import { LocalizationMessages } from "../../localization/messages";

const HelpWidgetMenu = props => {
  const { trackingInfo } = props;
  const { handleHelpCenter } = useCommunicationHandlers();

  const helpItem = useMemo(
    () =>
      new Item({
        title: LocalizationMessages.helpCenter,
        iconKey: "help"
      }),
    []
  );

  return (
    <MenuItem
      item={helpItem}
      onClick={handleHelpCenter}
      automationId="uc-help"
      trackingInfo={trackingInfo}
    />
  );
};

HelpWidgetMenu.propTypes = {
  trackingInfo: PropTypes.object
};

export default HelpWidgetMenu;
